// extracted by mini-css-extract-plugin
module.exports = {"signInMobileLabel":"az_hOc","fixedSignInMobileIconAndLabel":"az_iOc","signInIcon":"az_jOc"};